<template>
  <div class="pb-4 flex justify-between gap-4">
    <div class="flex-1">
      <TText variant="semibold" classes="mb-0">
        {{ name }}
      </TText>
      <TText size="sm" color="text-gray-600" classes="mb-0">
        {{ description }}
      </TText>
    </div>
    <div class="shrink-0 flex flex-col items-end">
      <UBadge
        v-if="oldPrice"
        color="error"
        variant="subtle"
        size="md"
        icon="i-lucide-tag"
      >
        {{ t('views.cottage-contact-prebooking.resume.total.deal') }}
      </UBadge>
      <div class="flex gap-x-1">
        <TText
          v-if="oldPrice"
          size="lg"
          color="text-gray-600"
          classes="mb-0 text-right line-through"
        >
          {{ toEuro(oldPrice) }}
        </TText>
        <TText
          size="lg"
          :variant="oldPrice ? 'semibold' : 'normal'"
          classes="mb-0 text-right"
        >
          {{ toEuro(price) }}
        </TText>
      </div>
    </div>
  </div>
</template>
<script lang="ts" setup>
defineProps<{
  name: string
  oldPrice?: number
  price: number
  description?: string
}>()
</script>
